import { saveAs } from "file-saver/src/FileSaver";
import store from "src/store/store";
import vueMainInstance from "../main";

export default function(url, method = "GET", data = {}) {
  vueMainInstance
    .axios({
      url: url,
      method: method,
      data: data,
      params: data,
      responseType: "blob"
    })
    .then(response => {
      const filename = response.headers["content-disposition"].substring(21); // after "attachment; filename="
      if (response.data.size === 0) {
        store.dispatch("alertDialog", {
          content: "Brak załączonych plików.",
          title: "Pobieranie plików"
        });
      } else {
        let blob = new Blob([response.data], {
          type: response.headers["content-type"]
        });
        saveAs(blob, filename);
      }
    })
    .catch(function(error) {
      console.log("Error Result"); // console logi w razie problemów żeby użytkownik mógł opisać problem
      console.log(error.message);
      console.log(error.response);
      console.log(error.request);
      console.log(error);
      store.dispatch("alertDialog", {
        content: "Nie udało się pobrać pliku. Kod błędu: " + error.response.status,
        title: "Wystąpił błąd"
      });
    });
}
